import { Component, inject, OnInit } from "@angular/core";
import { ConfirmModalData } from "./confirm-modal.data";
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { TranslatePipe } from "@ngx-translate/core";
@Component({
    selector: "app-confirm-modal",
    templateUrl: "confirm-modal.component.html",
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
        TranslatePipe,
    ],
})
export class ConfirmModalComponent {
    private readonly data = inject<ConfirmModalData>(MAT_DIALOG_DATA);
    readonly title = this.data.title.trim();
    readonly message = this.data.message.trim();
    readonly infoText = this.data.infoText?.trim();
    readonly confirmText = this.data.confirmText?.trim();
    readonly cancelText = this.data.cancelText?.trim();
}
